import { LineWin, PlayWindow } from "../../api";
import { IChangeableInterval, Interval } from "../../Context/Interval";
import { Color, CreateElement, LogGroup, Rect, Size } from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Settings } from "../../Settings";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";
import { ISprite } from "../Sprite/ISprite";
import { WinLineInfo1Marker } from "../WinLineInfo1Marker";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
import { GenericWinLinesAnimation, WinLinesAnimationParams } from "./GenericWinLinesAnimation";
import { WinSquareAnimationsElements, WinSquareAnimationsParams } from "./WinSquaresAnimations";

export class WinSquares1MarkerAnimation extends GenericWinLinesAnimation {

	protected sprite: ISprite;
	protected logGroup: LogGroup;
	protected spinnableReels: ISpinnableReels;
	protected resid: ResourceIdentifier;
	protected symbolSize: Size;
	protected viewSize: Size;
	protected slotWindow: Rect = null;
	protected slotWindowSymbolSize: PlayWindow = null;
	protected elements: WinSquareAnimationsElements[] = [];
	protected view: HTMLElement;
	protected lines: number[][];
	protected squareDuration: number;

	protected commonResourcesBasePath: String = Settings.ResourcesFolder + "multigame/slot/common/";


	protected resultLines: LineWin[];
	protected currentResultLineIndex: number = 0;
	protected nextLineInterval: IChangeableInterval = null

	protected readonly animateOnlyWinningSymbols: boolean = true;
	//Create Markers for win Lines
	protected winLineMarkers: WinLineInfo1Marker = null;
	protected running: boolean = false;
	protected colorMarkers : MarkersInfoColors = null;

	//constructor(viewSize: Size, slotWindow: PixelRect, slotWindowSymbolSize:Size, spinnableReels: SpinnableReels, logGroup: LogGroup, resid: ResourceIdentifier)
	constructor(params: WinLinesAnimationParams) {
		super();
		this.viewSize = params.viewSize;
		this.spinnableReels = params.spinnableReels;
		this.logGroup = params.logGroup.Add("WinSquaresInfoMakersAnimation");
		this.resid = params.resid.Add("WinSquaresInfoMakersAnimation");
		this.slotWindow = params.spinnableReels.GetWindowRect();
		this.slotWindowSymbolSize = params.spinnableReels.GetWindowSymbolSize();
		this.squareDuration = params.speedFactorAnimation;

		this.symbolSize = params.spinnableReels.GetSymbolSize();

		this.lines = params.lines;

		this.colorMarkers = params.colorLineMarkers;


		this.view = CreateElement("div", {
			classes: ["WinSquaresInfoMakersAnimation"], style: {
				position: "absolute",
				top: "0px",
				left: "0px",
				width: this.viewSize.Width + "px",
				height: this.viewSize.Height + "px",
				pointerEvents: "none"
			}
		});



		this.nextLineInterval = new Interval(this.resid, () => this.NextLine(), 2000);
		this.winLineMarkers = new WinLineInfo1Marker(params.slotWindow, this.spinnableReels.GetWindowSymbolSize(), this.lines);
	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		resourceManager.AddGlobal(new SpriteResource(this.commonResourcesBasePath + "resources/neonsquare", ResourceIdentifier.Global.Add("neonsquare").Add("neonsquare"), true, this.logGroup.Add("neonsquare"), true));
	}

	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.sprite = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("neonsquare").Add("neonsquare")).sprite;
		this.winLineMarkers.CreateGroups(this.colorMarkers);

		// here we have the sprite loaded, we can create Elements (element requires sprite passed via constructor)

		let numberOfColumns = this.spinnableReels.GetWindowSymbolSize().Width;
		for (let i = 0; i < numberOfColumns; i++) {
			let params: WinSquareAnimationsParams = {
				index: i,
				sprite: this.sprite.Copy(),
				symbolSize: this.spinnableReels.GetSymbolSize(),
				spinnableReels: this.spinnableReels
			}
			// create Element
			let element = new WinSquareAnimationsElements(params);

			// save element to array
			this.elements.push(element);

			// append elements view to animations view		
			this.view.appendChild(element.View());
			this.view.appendChild(this.winLineMarkers.LeftView());
			this.view.appendChild(this.winLineMarkers.RightView());
			
		}

	}


	public Start(resultLines: LineWin[], duration: number): void {

		this.running = true;

		if (resultLines.length > 0) {
			// Log.Debug(this.logGroup, "Start");
			this.squareDuration = duration;
			this.resultLines = resultLines;
			this.currentResultLineIndex = 0;

			// TODO use duration for interval!
			this.nextLineInterval.ChangeInterval(this.squareDuration);
			this.nextLineInterval.Start();

			// show first line right await
			this.NextLine();
		}
	}

	protected Stop(interrupted: boolean) {
		this.running = false;
		this.nextLineInterval.Stop();
		for (let column = 0; column < this.elements.length; column++) {
			this.elements[column].Stop();
		}

		this.OnComplete(interrupted);
	}


	protected NextLine() {

		// check if any lines remaining
		// if not, stop the interval and hide squares

		if (this.currentResultLineIndex >= this.resultLines.length) {
			
			this.Stop(false);
			return;
		}

		// show current line
		let currentResultLine: LineWin = this.resultLines[this.currentResultLineIndex];

		// this holds rows for each column 0, 1, 2, 1, 0
		let currentLine: number[] = this.lines[currentResultLine.LineIndex];

		// Log.Debug(this.logGroup, "Showing line " + this.currentResultLineIndex, currentLine);

		let symbols = currentResultLine.SymbolCount;
		let column = 0

		// show only first symbols
		for (; column < symbols; column++) {
			let row = currentLine[column];

			// here we would tell to what row it should move that particular square
			this.elements[column].Start(row, this.currentResultLineIndex == 0);
		}

		// hide remaining squares
		for (; column < this.elements.length; column++) {
			this.elements[column].Stop();
		}


		if (this.currentResultLineIndex == 0) {
			this.OnStartLine(currentResultLine, Color.FromRGBA(255,0,0,1) ,this.animateOnlyWinningSymbols);
		}

		this.OnNextLine(currentResultLine, Color.FromRGBA(255,0,0,1), this.animateOnlyWinningSymbols);


		this.currentResultLineIndex++;

	}

	public RequestStop(): void {
		this.Stop(true);
	}

	// TODO need to check...
	// do we even need that?
	// we have "OnComplete" callback, that signals when its complete
	public GetDuration(): number {
		return this.resultLines.length * this.squareDuration;;
	}

	public Update(): void {
		// update sprites, when running
		if (this.running)
		{
			for (let i = 0; i < this.elements.length; i++) {
				this.elements[i].Update();
			}
		}
	}

	public View(): HTMLElement {
		return this.view;
	}

	protected MarkesInfoBackground(): MarkersInfoColors
	{
        let color: MarkersInfoColors =
        {
			MarkerbackgroundColor: "linear-gradient(90deg, rgba(6,65,42,1) 0%, rgba(117,255,9,1) 35%, rgba(183,255,9,1) 55%, rgba(117,255,9,1) 75%, rgba(6,65,42,1) 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			//linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%",
        };
        
		return color;
	}
}